import React, { useCallback, useEffect, useState } from "react";

import { getUserSettings, updateUserSetting } from "services";

import { useCancelAsyncOnUnmount, useToggleNavs, useTranslation, useUserContext } from "utils";

import { Col, Link, MainPage, NavigationHeader, Row, Switch } from "components";

export const ProfilePrivacy = () => {
  const { t } = useTranslation(["user", "meta"]);
  const { user } = useUserContext();
  useToggleNavs(!!user, false);

  const [shareData, setShareData] = useState(false);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();

  const handleSwitch = () => {
    setShareData(!shareData);
    updateUserSetting({
      item: "dataShare",
      value: !shareData,
    });
  };

  const loadUserSettings = useCallback(() => {
    setLoading(true);

    getUserSettings({
      signal,
    })
      .then((res) => {
        setShareData(res.dataShare);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadUserSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"profile"} containerClass="tiny">
      <NavigationHeader title={t("privacySettings.headerTitle")} />
      <Row>
        <Col>
          <h1>{t("privacySettings.headline")}</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>{t("privacySettings.description")}</p>
        </Col>
      </Row>
      <Row className="margin-top-400">
        <Col>
          <h2>{t("privacySettings.shareProgress.headline")}</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="margin-top-200">{t("privacySettings.shareProgress.description.hp")}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Link to="/privacy-policy" target="_blank" mixpanelText={t("privacySettings.shareProgress.readMore")}>
            {t("privacySettings.shareProgress.readMore")}
          </Link>
        </Col>
      </Row>
      <Row className="margin-top-400">
        <Col>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>{t("privacySettings.shareProgress.agree")}</p>{" "}
            <Switch className={shareData ? "active" : "inactive"} checked={shareData} onClick={(v) => handleSwitch(v)} />
          </div>
        </Col>
      </Row>
    </MainPage>
  );
};
